import React, { Fragment, Suspense, useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Loader from "../Layout/Loader";
import Signin from "../Auth/Signin";
import LayoutRoutes from "./LayoutRoutes";
import { authRoutes } from "./AuthRoutes";
import PrivateRoute from "./PrivateRoute";
import ScrollToTop from "../Services/ScrollToTop";
import { AuthProvider } from "../Context/AuthContext";
import TandaTerima from "../Pages/TandaTerima";
import Layout from "../Layout/Layout";
import AppProvider from "../Context/AppProvider";
import Cabil from "../Pages/Cabil";
import Cabil2 from "../Pages/Cabil2";
import Cabil3 from "../Pages/Cabil3";
import Bajo from "../Pages/Bajo";

const Routers = () => {
  const [isKurir, setIsKurir] = useState(false);

  useEffect(() => {
    const groups = localStorage.getItem("group");
    if (groups) {
      try {
        if (groups.includes("kurir")) {
          setIsKurir(true);
        } else {
          setIsKurir(false);
        }
      } catch (error) {
        console.error("Error parsing group from localStorage:", error);
        setIsKurir(false);
      }
    }
  }, []);
  return (
    <Fragment>
      <BrowserRouter basename={"/"}>
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <AuthProvider>
            <AppProvider>
              <Routes>
                <Route path={"/bajo"} element={<Bajo />}/>
                <Route path={"/form"} element={<Cabil/>}/>
                <Route path={"/form2"} element={<Cabil2/>}/>
                <Route path={"/form3"} element={<Cabil3/>}/>
                <Route path={"/"} element={<PrivateRoute />}>
                  <Route
                    path="/"
                    element={
                      isKurir ? (
                        <Navigate to={`${process.env.PUBLIC_URL}/tandaterima`} replace />
                      ) : (
                        <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />
                      )
                    }
                  />
                  <Route
                    exact
                    path={`/sipeg`}
                    element={
                      isKurir ? (
                        <Navigate to={`${process.env.PUBLIC_URL}/tandaterima`} replace />
                      ) : (
                        <Navigate to={`${process.env.PUBLIC_URL}/dashboard`} replace />
                      )
                    }
                  />
                  {isKurir ? (
                    <Route
                      path={`/*`}
                      element={
                        <Routes>
                          <Route element={<Layout />}>
                            <Route
                              path={`${process.env.PUBLIC_URL}/tandaterima`}
                              element={<TandaTerima />}
                            />
                          </Route>
                        </Routes>
                      }
                    />
                  ) : (
                    <Route path={`/*`} element={<LayoutRoutes />} />
                  )}
                </Route>
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/login`}
                  element={<Signin />}
                />
                {authRoutes.map(({ path, Component }, i) => (
                  <Route path={path} element={Component} key={i} />
                ))}
              </Routes>
            </AppProvider>
          </AuthProvider>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};
export default Routers;